import { defineMessages } from '@formatjs/intl';

const messages = defineMessages({
	codeInputLabel: {
		id: 'campaign.codeEntry.inputLabel',
		defaultMessage: 'Enter your code',
		description: 'Campaign Code Entry Input Label',
	},
	submitCta: {
		id: 'campaign.codeEntry.submitCta',
		defaultMessage: 'Submit',
		description: 'Campaign Code Entry Submit Button',
	},
	invalid: {
		id: 'campaign.codeEntry.error.invalid',
		defaultMessage: "This code isn't valid. Please double-check and try again.",
		description: 'Shown when the entered campaign code does not exist',
	},
	expired: {
		id: 'campaign.codeEntry.error.expired',
		defaultMessage: 'This code has expired.',
		description: 'Shown when the entered campaign code has expired',
	},
	alreadyUsed: {
		id: 'campaign.codeEntry.error.alreadyUsed',
		defaultMessage: 'This code has already been used.',
		description: 'Shown when the entered campaign code has already been redeemed',
	},
	deleted: {
		id: 'campaign.codeEntry.error.deleted',
		defaultMessage: 'This code is no longer available.',
		description: 'Shown when the entered campaign code has been deleted',
	},
	generic: {
		id: 'campaign.codeEntry.error.generic',
		defaultMessage: 'Something went wrong. Please try again.',
		description: 'Shown when validating the campaign code fails for any transport-level reason',
	},
	contactPrompt: {
		id: 'campaign.codeEntry.contactPrompt',
		defaultMessage: 'Need help? Contact {contactEmail}.',
		description: "Prompt pointing the user to the campaign's support contact email",
	},
});

export default messages;
